import * as React from 'react';
import { FoldersListItem } from '../../components/FoldersList/FoldersListItem';
import { selectFolder } from '../../actions/folders/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCount, selectSelectedId } from '../../selectors/folders';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { getTextCount } from '../../utils/favoriteEntity';
import { unselectAll } from '../../actions/selected';
import { addQueryToHistory } from '../../hooks/browserHistory';

const folderIcon = require('./img/folder.png');

export function FoldersListItemAllContainer() {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);
  const totalCount = useSelector(selectAllCount);

  const handleClick = () => {
    addQueryToHistory({});
    dispatch(selectFolder({ folder: null }));
    dispatch(unselectAll());
    dispatch(fetchFavoriteEntities({ offset: 0 }));
  };

  return (
    <FoldersListItem
      image={<img src={folderIcon} />}
      selected={!selectedFolderId}
      title="Все объявления"
      description={getTextCount(totalCount)}
      onClick={handleClick}
    />
  );
}
